import React from 'react';
import { CostPerBlockFeature, ConcurrentCCRFeature } from './SharedApiFeatures';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'stt-streaming';

const sttStreamingFeatures = ({ packages, sttConfig }) => ({
  enabled: {
    key: 'stt-streaming-enabled',
    label: 'sttStreaming',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerBlock: {
    key: 'stt-streaming-cost-per-block',
    label: 'costPerBlock',
    values: packages.map((pkg) => (
      <CostPerBlockFeature
        key={pkg.code}
        pkg={pkg}
        creditPerBlock={sttConfig?.creditPerBlock}
        featureName="stt-streaming"
      />
    )),
  },
  concurrentCCR: {
    key: 'stt-streaming-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.stt?.streaming}
      />
    )),
  },
});

export default sttStreamingFeatures;
